import { Box, Button, Stack, Typography } from "@mui/material";
import Map from "../../map/map.component";
import { getFieldTypeName } from "../utils";

const InfoStack = ({
  fontSizeLabel,
  theme,
  label,
  text,
  fontSizeText,
  isBold = false,
}) => {
  return (
    <Stack direction="column">
      <Typography
        fontSize={fontSizeLabel}
        color={theme.palette.custom.infoTextColor}
      >
        {label}
      </Typography>
      <Typography
        fontSize={fontSizeText}
        fontWeight={isBold ? "bold" : "normal"}
      >
        {text}
      </Typography>
    </Stack>
  );
};

const SubAreaCard = ({
  theme,
  onDelete,
  onEdit,
  savedData,
  editable = true,
  fieldPosition,
  fieldsType,
}) => {
  const handleEdit = () => {
    if (onEdit) {
      onEdit(savedData);
    }
  };

  return (
    <Box
      width="100%"
      display="flex"
      alignItems="center"
      justifyContent="center"
      flexDirection="column"
      bgcolor={theme.palette.custom.backgroundColor}
      p={2}
    >
      <Box
        width="100%"
        display="flex"
        alignItems="center"
        justifyContent="space-between"
      >
        <Typography fontWeight="bold" fontSize="14px">
          Sottoterreno
        </Typography>
        {editable && (
          <Stack direction="row" spacing={2}>
            <Button
              variant="text"
              sx={{ textTransform: "none", textDecoration: "underline" }}
              size="small"
              onClick={handleEdit}
            >
              Modifica
            </Button>
            <Button
              variant="text"
              sx={{ textTransform: "none", textDecoration: "underline" }}
              size="small"
              onClick={() => onDelete && onDelete(savedData)}
            >
              Elimina
            </Button>
          </Stack>
        )}
      </Box>
      <Box display="flex" width="100%" gap={2}>
        <Box width="170px" height="150px" zIndex={0}>
          <Map
            zoomLevel={7}
            fieldPosition={[40.0647, 9.1217]}
            polygonCoordinates={fieldPosition}
            showLayersControl={false}
            showZoomControl={false}
            subAreas={[savedData]}
          />
        </Box>
        <Box
          width="100%"
          display="flex"
          flexDirection="column"
          justifyContent="start"
        >
          <InfoStack
            fontSizeLabel="8px"
            theme={theme}
            label="Nome"
            fontSizeText="20px"
            text={savedData?.name || savedData?.subAreaName}
            isBold
          />
          <Box display="flex" alignItems="center" gap={2} mt={2}>
            <InfoStack
              fontSizeLabel="8px"
              theme={theme}
              label="Tipologia"
              fontSizeText="14px"
              text={
                savedData?.field_type?.name ||
                getFieldTypeName(fieldsType, savedData?.subAreaType)
              }
            />
            <InfoStack
              fontSizeLabel="8px"
              theme={theme}
              label="Sostanza Organica"
              fontSizeText="14px"
              text={
                savedData?.organic_soil_percentage
                  ? `${savedData?.organic_soil_percentage}%`
                  : savedData?.organicSubstance
                  ? `${savedData?.organicSubstance}%`
                  : "-"
              }
            />
            <InfoStack
              fontSizeLabel="8px"
              theme={theme}
              label="Densità Pietre"
              fontSizeText="14px"
              text={
                savedData.stone_percentage
                  ? `${savedData?.stone_percentage}%`
                  : savedData?.stoneDensity
                  ? `${savedData?.stoneDensity}%`
                  : "-"
              }
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default SubAreaCard;
